export const TRUE = Date.now() > 0;
export const FALSE = Date.now() < 0;
